import * as bc from "bc-js";
import * as navigation from "@oel/js-navigation";

import { Alerte } from "../../commun/Alerte/Alerte";
import { GabaritNavigationUtil } from '../../../utils/gabarit-navigation/GabaritNavigationUtil';
import { LangueUtils } from "@oel/js-i18n";
import { ResilienceUtil } from "../../../utils/ResilienceUtil";
import { en } from './i18n/AccueilAffaires.i18n.en';
import { fr } from './i18n/AccueilAffaires.i18n.fr';
import { useEffect } from 'react';
import { IdPageEnum } from "../../../utils/gabarit-navigation/IdPageEnum";

export function AccueilAffaires() {
    const libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = libelles.titreOnglet;

        ResilienceUtil.rendreResilientSiProbleme("bc", () => bc.changerContexte("PRODUCT_Summary"));

        gererNavInitial();
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.ACCUEIL_ADA);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function gererNavInitial() {
        const windowLocationSearch = window.location.search;
        navigation.ModaleService.gererOuvertureModale(windowLocationSearch);
    }

    return (
        <div className="accueil-affaires">
            <h1 className="dsd-sr-only" id="titre-page-pour-retour-contenu-principal">{libelles.titre}</h1>
            <accueil-affaires>
                <div slot="alertes-generiques"><Alerte /></div>
            </accueil-affaires>
        </div>
    );
}
